export default {
    parts: [
        'checkboxLabel',
        'checkboxIcon',
        'dropdownTrigger',
        'dropdownSelectedLabel',
        'dropdownPanel',
        'dropdownCreateContainer',
        'dropdownCreateInner',
        'dropdownCreateButton',
        'dropdownList',
        'dropdownFooter',
        'dropdownFooterButton'
    ],
    baseStyle: {
        checkboxLabel: {
            alignItems: 'flex-start',
            gap: 3,
            cursor: 'pointer',
            py: '14px',
            px: 0,
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            _last: {borderBottom: 'none'},
            userSelect: 'none'
        },
        checkboxIcon: {
            flexShrink: 0,
            w: '20px',
            h: '20px',
            mt: '1px',
            border: '1.5px solid',
            borderRadius: '2px',
            alignItems: 'center',
            justifyContent: 'center'
        },
        dropdownTrigger: {
            alignItems: 'center',
            justifyContent: 'space-between',
            border: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            borderRadius: 0,
            px: 3,
            h: '50px',
            cursor: 'pointer',
            bg: 'white',
            position: 'relative',
            _hover: {borderColor: 'webTheme.strokeSecondary'}
        },
        dropdownSelectedLabel: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textSecondary',
            lineHeight: '1.2',
            mb: '1px'
        },
        dropdownPanel: {
            position: 'absolute',
            top: 'calc(100% + 4px)',
            left: 0,
            right: 0,
            border: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            backgroundColor: 'webTheme.fieldDefault',
            borderRadius: 0,
            zIndex: 10,
            boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
        },
        dropdownCreateContainer: {
            mx: 3,
            my: 3,
            border: '1px solid',
            borderColor: 'webTheme.strokeSecondary'
        },
        dropdownCreateInner: {
            alignItems: 'center',
            gap: 3,
            px: 3,
            py: 2
        },
        dropdownCreateButton: {
            textStyle: 'ctaUnderlined',
            textTransform: 'uppercase',
            h: 'auto',
            minW: 'auto',
            px: 0,
            flexShrink: 0,
            color: 'webTypo.textPrimary'
        },
        dropdownList: {
            px: 3,
            maxH: '240px',
            overflowY: 'auto'
        },
        dropdownFooter: {
            gap: 2,
            px: 3,
            py: 3,
            borderTop: '1px solid',
            borderColor: 'webTheme.strokeTertiary'
        },
        dropdownFooterButton: {
            flex: '1',
            h: '44px'
        }
    }
}
